import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { FiClock, FiXCircle, FiBriefcase, FiRefreshCw } from 'react-icons/fi';
import { TbAlertCircleFilled } from "react-icons/tb";
import RPAInfo from '../components/RPAinfo';

import '../css/styles.css';
import '../css/general.css';
import '../css/queries.css';

const HomeScreen = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send(window.location.pathname);
  }, []);

  const basePath = location.pathname.startsWith('/uk') ? '/uk' : '';
  const isUK = basePath === '/uk';

  const GRAPH_BASE = 'https://s3.us-east-1.amazonaws.com/media.datascalp.com/Graphs';

  const getGraphUrl = (name) => {
    return isUK
      ? `${GRAPH_BASE}/uk_${name}`
      : `${GRAPH_BASE}/${name}`;
  };

  return (
    <div className="section-report-incident">
      <div className="container incident-flex">
        {/* Sidebar */}
        <RPAInfo />

        {/* Main Content */}
        <div style={{ padding: '20px 10px' }}>
          <div className="form-area">

            {/* Mobile Report Button */}
            <div className="text-center">
              <Link
                className="mobile-report-incident mobile-report-incident-1"
                to={`${basePath}/report`}
              >
                Report Incident
              </Link>
            </div>

            {/* Disclaimer */}
            <div className="disclaimer-box">
              <div className="disclaimer-icon">
                <TbAlertCircleFilled size={32} />
              </div>

              <div className="disclaimer-text">
                <strong>Disclaimer: </strong>
                <span>
                  Images are for illustrative purposes only and do not reflect actual results.
                </span>
              </div>
            </div>

            {/* Dashboard Grid */}
            <div className="ds-dashboard-grid">

              {/* On Time Performance */}
              <div className="ds-metric-card">
                <div className="ds-metric-header">
                  <FiClock /> On Time Performance
                </div>
                <div className="ds-metric-body">
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('best_on_time.png')}
                      alt="Best On Time Performance"
                      className="ds-chart-img"
                    />
                  </div>
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('worst_on_time.png')}
                      alt="Worst On Time Performance"
                      className="ds-chart-img"
                    />
                  </div>
                </div>
              </div>

              {/* Cancellations */}
              <div className="ds-metric-card">
                <div className="ds-metric-header">
                  <FiXCircle /> Cancellations
                </div>
                <div className="ds-metric-body">
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('best_cancellations.png')}
                      alt="Best Cancellations"
                      className="ds-chart-img"
                    />
                  </div>
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('worst_cancellations.png')}
                      alt="Worst Cancellations"
                      className="ds-chart-img"
                    />
                  </div>
                </div>
              </div>

              {/* Baggage Accuracy */}
              <div className="ds-metric-card">
                <div className="ds-metric-header">
                  <FiBriefcase /> Baggage Accuracy
                </div>
                <div className="ds-metric-body">
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('best_baggages.png')}
                      alt="Best Baggage Accuracy"
                      className="ds-chart-img"
                    />
                  </div>
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('worst_baggages.png')}
                      alt="Worst Baggage Accuracy"
                      className="ds-chart-img"
                    />
                  </div>
                </div>
              </div>

              {/* Time to Refund */}
              <div className="ds-metric-card">
                <div className="ds-metric-header">
                  <FiRefreshCw /> Time to Refund
                </div>
                <div className="ds-metric-body">
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('best_cancellation_refund.png')}
                      alt="Best Time to Refund"
                      className="ds-chart-img"
                    />
                  </div>
                  <div className="ds-chart-box">
                    <img
                      src={getGraphUrl('worst_cancellation_refund.png')}
                      alt="Worst Time to Refund"
                      className="ds-chart-img"
                    />
                  </div>
                </div>
              </div>

            </div>

            {/* Report Button */}
            <div className="text-center">
              <Link className="report-btn" to={`${basePath}/report`}>
                📄 Report Incident →
              </Link>
            </div>
          </div>

          {/* Bottom Info */}
          <div className="info-container">
            <span className="info-text">
              Empowering travelers to report their experiences not only aids other travelers
              but also assists airlines in gathering data on potential areas for improvement.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;